/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TelegramVerificationResponse
 */
export interface TelegramVerificationResponse {
    /**
     * Indicates whether the token was valid and the link was successfully established.
     * @type {boolean}
     * @memberof TelegramVerificationResponse
     */
    success: boolean;
}

/**
 * Check if a given object implements the TelegramVerificationResponse interface.
 */
export function instanceOfTelegramVerificationResponse(value: object): value is TelegramVerificationResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    return true;
}

export function TelegramVerificationResponseFromJSON(json: any): TelegramVerificationResponse {
    return TelegramVerificationResponseFromJSONTyped(json, false);
}

export function TelegramVerificationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TelegramVerificationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
    };
}

export function TelegramVerificationResponseToJSON(json: any): TelegramVerificationResponse {
    return TelegramVerificationResponseToJSONTyped(json, false);
}

export function TelegramVerificationResponseToJSONTyped(value?: TelegramVerificationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
    };
}

